import React, { useContext, useEffect, useState } from "react";
import classes from "./EditServices.module.scss";
import { Collapse, Container, OverlayTrigger, Row, Tooltip,Col } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { DDD, E2Data } from "../lib/ddd/ddd";
import { ClientTypes, OrgIdContext } from "../store/orgId_context";
import Button from "../components/UI/Button";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { Checkbox, LinearProgress, Switch } from "@mui/material";
import { ReactComponent as CopyBtn } from "../assets/copy.svg";
import HelpIcon from '@mui/icons-material/Help';
import { NotificationManager} from 'react-notifications';
import LoadingDots from "../components/UI/LoadingDots";
import { ThreeDots } from "react-loader-spinner";
import PanoramaFishEyeIcon from '@mui/icons-material/PanoramaFishEye';
import CircleIcon from '@mui/icons-material/Circle';

const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";

const OperationMode = () => {
    const { integrationDevice,clientType, aboutOrgId, sessionInfo, connectionKeyMode, connectionKey, setConnectionKeyModeHandler, modeREI, setModeREIHandler} = useContext(OrgIdContext);
    const [sla, setSLA] = useState(connectionKeyMode==="PROD");
    const [terms, setTerms] = useState(connectionKeyMode==="PROD");
    const [sla2, setSLA2] = useState(modeREI==="PROD");
    const [terms2, setTerms2] = useState(modeREI==="PROD");
    const [copied, setCopied] = useState(false);
    const [copied2, setCopied2] = useState(false);
    const [reiLoading, setReiLoading] = useState(false);
    const [ieiLoading, setIeiLoading] = useState(false);
    const [reiError, setReiError] = useState();
    const [ieiError, setIeiError] = useState();
    const {t} = useTranslation();

    const openSLAAgreement = () => {
        window.open(process.env.REACT_APP_ORIGIN ?  process.env.REACT_APP_ORIGIN+`/Public/e785e9da-a600-4fb3-8520-8943d22e44aa?inline=true` : window.location.origin+`/Public/e785e9da-a600-4fb3-8520-8943d22e44aa?inline=true`, "_blank");
    };
    const openTermsAgreement = () => {
        window.open(process.env.REACT_APP_ORIGIN ?  process.env.REACT_APP_ORIGIN+`/Public/fa09445a-417a-43f7-a23b-c057e5082fe3?inline=true` : window.location.origin+`/Public/fa09445a-417a-43f7-a23b-c057e5082fe3?inline=true`, "_blank");
    };
    const onCpyConnKeyClick = () => {
        navigator.clipboard.writeText(connectionKey);

        setCopied(connectionKey);
        setTimeout(() => {
            setCopied(false);
        }, 1500);
    }
    const onCpyConnKeyClick2 = () => {
        navigator.clipboard.writeText(integrationDevice);

        setCopied2(integrationDevice);
        setTimeout(() => {
            setCopied2(false);
        }, 1500);
    }
    
    const onGoToProdClick = () => {
        if(ieiLoading) return;
        if(!sla || !terms) return NotificationManager.warning(t("You must first agree with SLA and Terms & Conditions (checkmarks above)"));
        if(connectionKeyMode==="PROD") return;
        setConnectionKeyModeHandler("PROD");
        //EUeInvoices.ChangeMode {Mode: "PROD", DeviceId : ""}
        const ddd = new DDD(apiRequestAddress);
        setIeiLoading(true);
        return ddd.Rpc_ExecuteExtension("EUeInvoices.ChangeMode", {Mode: "PROD", DeviceId: connectionKey}).then((res) => {
            setIeiLoading(false);
            if(res.result?.Status?.toLowerCase() !== "ok"){
                setConnectionKeyModeHandler("TEST");
                setIeiError(res.result?.Reason || t("An unknown error occured. Please contact administrator."));
                setTimeout(() => {setIeiError(false)}, 5000);
            }
        });
    }

    const onGoToProdClickREI = () => {
        if(reiLoading) return;
        if(!sla2 || !terms2) return NotificationManager.warning(t("You must first agree with SLA and Terms & Conditions (checkmarks above)"));
        if(modeREI==="PROD") return;
        setModeREIHandler("PROD");
        //EUeInvoices.ChangeModeREI {Mode: "PROD"}
        const ddd = new DDD(apiRequestAddress);
        setReiLoading(true);
        return ddd.Rpc_ExecuteExtension("EUeInvoices.ChangeModeREI", {Mode: "PROD"}).then((res) => {
            setReiLoading(false);
            if(res.result?.Status?.toLowerCase() !== "ok"){
                setModeREIHandler("TEST");
                setReiError(res.result?.Reason || t("An unknown error occured. Please contact administrator."));
                setTimeout(() => {setReiError(false)}, 5000);
            }
        });
    }

    const copyAPIKey = () =>{
        navigator.clipboard.writeText(connectionKey);
        NotificationManager.success(``, t("Copied!"));
    }
    
    return (
    <>
      <Helmet>
        <title>Operation mode | DDD Invoices</title>
      </Helmet>
      <div className={`h-100 w-100 p-5 ${classes.container}`}>
        <Row>
            <Col className="col-12 col-md-6">
                <div>
                    <div className={classes.smollTitle}>{t("Issued")}</div>
                    <div className="mt-2 mb-2">{t("By enabling this option, you will allow your company to send real invoices into the production environment of the Tax Authority and to other chosen e-paths to reach your buyer.")}</div>
                    <Row style={{fontSize:"0.7rem", textWrap:"nowrap"}}>
                        <Col>
                        <Checkbox id="slach" checked={sla} size="small" disabled={connectionKeyMode==="PROD"} onChange={(e) => setSLA(e.target.checked)}/>
                        <label role="button" for="slach">{t("I agree with SLA")}</label>
                        <OverlayTrigger placement="top" overlay={<Tooltip>{t("Open SLA agreement")}</Tooltip>}>
                            <svg onClick={openSLAAgreement} className={`ms-2 ${classes.pointer}`} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="15" height="15" fill="grey" aria-hidden="true">
                                <path d="M14 3h6a1 1 0 011 1v6a1 1 0 11-2 0V6.414l-9.293 9.293a1 1 0 01-1.414-1.414L17.586 5H14a1 1 0 110-2z" />
                                <path d="M5 5h6a1 1 0 010 2H6v12h12v-5a1 1 0 112 0v6a1 1 0 01-1 1H5a1 1 0 01-1-1V6a1 1 0 011-1z"/>
                            </svg>
                        </OverlayTrigger>
                        <Checkbox className="ms-4" id="tcch" checked={terms} disabled={connectionKeyMode==="PROD"} size="small" onChange={(e) => {setTerms(e.target.checked)}}/>
                        <label role="button" for="tcch">{t("I agree with Terms & conditions")}</label>
                        <OverlayTrigger placement="top" overlay={<Tooltip>{t("Open Terms & Conditions")}</Tooltip>}>
                            <svg onClick={openTermsAgreement} className={`ms-2 ${classes.pointer}`} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="15" height="15" fill="grey" aria-hidden="true">
                                <path d="M14 3h6a1 1 0 011 1v6a1 1 0 11-2 0V6.414l-9.293 9.293a1 1 0 01-1.414-1.414L17.586 5H14a1 1 0 110-2z" />
                                <path d="M5 5h6a1 1 0 010 2H6v12h12v-5a1 1 0 112 0v6a1 1 0 01-1 1H5a1 1 0 01-1-1V6a1 1 0 011-1z"/>
                            </svg>
                        </OverlayTrigger>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="col-md-6">
                            {ieiLoading && <LinearProgress sx={{
                                '& .MuiLinearProgress-bar': {
                                backgroundColor: '#005683',
                                },
                                backgroundColor: '#b1d1e1',
                            }}/>}
                            <div className="d-flex justify-content-evenly align-items-center mt-3">
                                <span className={classes.smollTitle2}>Test</span>
                                <Switch sx={{transform:"scale(1.4)"}} checked={connectionKeyMode==="PROD"} onClick={onGoToProdClick} /* disabled={!sla || !terms} *//>
                                <span className={classes.smollTitle2}>Production</span>
                            </div>
                            <Row>
                                <Col className="col-md-1"></Col>
                                <Col className="col-md-8 text-center" style={{fontSize:"0.6rem"}}>{t("No stress! Preliminary checks will take place, before actually switching to prod.")}</Col>
                                <Col></Col>
                            </Row>
                        </Col>
                        <Col className="col-md-6">
                            {/* {connectionKey && <><div>API Key:
                                <OverlayTrigger placement="bottom" overlay={<Tooltip>{t("This is your company's Connection Key. All invoices sent from your solution to our service using this key will automatically be sent to the test (and not the production) environment - until you arrange the necessary communication credentials as and switch your company to the production mode of operation with a switch on the left.")}</Tooltip>}>
                                    <HelpIcon style={{marginLeft:"0.5rem", fontSize:"1rem", color:"var(--main-blue)"}}/>
                                </OverlayTrigger>
                                {copied && <span>(Copied!)</span>}
                            </div>
                            <div className={classes["connIdText"]} onClick={onCpyConnKeyClick}>
                                <span >{connectionKey}</span>
                                <CopyBtn className="ps-2"/>
                            </div></>} */}
                            {connectionKey && <div className="d-flex justify-content-center align-items-center position-relative flex-column" >
                                <span style={{color:"var(--main-orange)", marginRight:"0.3rem", alignSelf:"start"}}>
                                {clientType !== ClientTypes.ISV && connectionKeyMode !== "PROD" && 
                                <OverlayTrigger placement="bottom" overlay={<Tooltip>{t("In test mode")}</Tooltip>}>
                                    <PanoramaFishEyeIcon style={{fontSize:"0.9rem", color:"var(--main-blue)", marginRight:"0.2rem"}}/>
                                </OverlayTrigger> }
                                    
                                {clientType !== ClientTypes.ISV && connectionKeyMode === "PROD" && 
                                <OverlayTrigger placement="bottom" overlay={<Tooltip>{t("In production")}</Tooltip>}>
                                    <CircleIcon style={{fontSize:"0.9rem", color:"green", marginRight:"0.2rem"}}/>
                                </OverlayTrigger> }
                                API key
                                <OverlayTrigger placement="bottom" overlay={<Tooltip>{t("Currently in")}:<span className="fw-bold ms-2">{connectionKeyMode === "PROD" ? "Production" : "Test"}</span><br/>{t("This is your company's Connection Key. Invoices sent with this key go to the test environment only, until you set up the required authentication credentials for each distribution channels and switch the key to production mode. The key also includes your company's country info, which determines the e-invoice format and the tax authority portal used.")}</Tooltip>}>
                                    <HelpIcon style={{marginLeft:"0.5rem", fontSize:"1rem", color:"var(--main-blue)"}}/>
                                </OverlayTrigger>
                                </span>
                                <div className={`d-flex me-3 ${classes["apikey"]}`}  style={{color:"var(--main-blue)"}} onClick={copyAPIKey}>
                                    {connectionKey}
                                <CopyBtn style={{fill:"var(--main-blue)", transform:"scale(0.7)"}}/>
                                </div>
                            </div>}
                            {connectionKeyMode==="PROD" && integrationDevice && <>
                                <div className="mt-3">Test Key:
                                    <OverlayTrigger placement="bottom" overlay={<Tooltip>{t("Since your main API key is already in production mode you can use the following key if you wish to futher test")}</Tooltip>}>
                                        <HelpIcon style={{marginLeft:"0.5rem", fontSize:"1rem", color:"var(--main-blue)"}}/>
                                    </OverlayTrigger>
                                    {copied2 && <span>(Copied!)</span>}
                                </div>
                                <div className={classes["connIdText"]} onClick={onCpyConnKeyClick2}>
                                    <span style={{color:"#595959"}}>{integrationDevice}</span>
                                    <CopyBtn className="ps-2"/>
                                </div>
                            </>}
                        </Col>
                    </Row>
                    {ieiError && <Row className="mt-3" style={{color:"red"}}><Col>{ieiError}</Col></Row>}
                </div>
            </Col>
            <Col className="col-12 col-md-6">
                <div>
                    <div className={classes.smollTitle}>{t("Received")}</div>
                    <div className="mt-2 mb-2">{t("By enabling this option, you will allow your company to receive real invoices from the production environment of the Tax Authority or other chosen e-paths.")}</div>
                    <Row style={{fontSize:"0.7rem", textWrap:"nowrap"}}>
                        <Col>
                        <Checkbox id="slach2" checked={sla2} size="small" disabled={modeREI==="PROD"} onChange={(e) => setSLA2(e.target.checked)}/>
                        <label role="button" for="slach2">{t("I agree with SLA")}</label>
                        <OverlayTrigger placement="top" overlay={<Tooltip>{t("Open SLA agreement")}</Tooltip>}>
                            <svg onClick={openSLAAgreement} className={`ms-2 ${classes.pointer}`} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="15" height="15" fill="grey" aria-hidden="true">
                                <path d="M14 3h6a1 1 0 011 1v6a1 1 0 11-2 0V6.414l-9.293 9.293a1 1 0 01-1.414-1.414L17.586 5H14a1 1 0 110-2z" />
                                <path d="M5 5h6a1 1 0 010 2H6v12h12v-5a1 1 0 112 0v6a1 1 0 01-1 1H5a1 1 0 01-1-1V6a1 1 0 011-1z"/>
                            </svg>
                        </OverlayTrigger>
                        <Checkbox className="ms-4" id="tcch2" checked={terms2} disabled={modeREI==="PROD"} size="small" onChange={(e) => {setTerms2(e.target.checked)}}/>
                        <label role="button" for="tcch2">{t("I agree with Terms & conditions")}</label>
                        <OverlayTrigger placement="top" overlay={<Tooltip>{t("Open Terms & Conditions")}</Tooltip>}>
                            <svg onClick={openTermsAgreement} className={`ms-2 ${classes.pointer}`} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="15" height="15" fill="grey" aria-hidden="true">
                                <path d="M14 3h6a1 1 0 011 1v6a1 1 0 11-2 0V6.414l-9.293 9.293a1 1 0 01-1.414-1.414L17.586 5H14a1 1 0 110-2z" />
                                <path d="M5 5h6a1 1 0 010 2H6v12h12v-5a1 1 0 112 0v6a1 1 0 01-1 1H5a1 1 0 01-1-1V6a1 1 0 011-1z"/>
                            </svg>
                        </OverlayTrigger>
                        </Col>
                    </Row>
                    <Row>
                        {reiLoading && <LinearProgress sx={{
                            '& .MuiLinearProgress-bar': {
                            backgroundColor: '#005683',
                            },
                            backgroundColor: '#b1d1e1',
                        }}/>}
                        <div className="d-flex align-items-center mt-3">
                            <span className={classes.smollTitle2}>Off</span>
                            {/* <LoadingDots/> */}
                            {/* <ThreeDots/> */}
                            <Switch className="ms-3 me-3" sx={{transform:"scale(1.4)"}} checked={modeREI==="PROD"} onClick={onGoToProdClickREI} /* disabled={!sla2 || !terms2} *//>
                            <span  className={classes.smollTitle2}>On</span>
                            <OverlayTrigger placement="bottom" overlay={<Tooltip>{t("Same API key is used for pulling invoices from our infrastructure to your solution.")}</Tooltip>}>
                                <HelpIcon style={{marginLeft:"0.5rem", fontSize:"1rem", color:"var(--main-blue)"}}/>
                            </OverlayTrigger>
                        </div>
                        <Row>
                            <Col className="col-md-4 text-center" style={{fontSize:"0.6rem"}}>{t("No stress! Preliminary checks will take place, before turning on.")}</Col>
                            <Col></Col>
                        </Row>
                    </Row>
                    {reiError && <Row className="mt-3" style={{color:"red"}}><Col>{reiError}</Col></Row>}
                </div>
            </Col>
        </Row>
      </div>
    </>
    );
};

export default OperationMode;
